import { useRef } from "react";
import { Link } from "react-router-dom";
const TeamCard = (props) => {
  const cardRef = useRef();
  const { handleFlipping, active, teamD } = props;
  const { id, image, imgAlt, name, position, discordIcon, twitterIcon, detail, discordLink, twitterLink, instaIcon, linkIcon, insta, website, hasDiscord, hasTwitter, hasInsta, hasWebsite, linkedinLink, linkedinIcon, hasLinkedin } = teamD;
  function createMarkup(c) {
    return { __html: c };
  }
  return (
    <div ref={cardRef} className={active === id ? "team card hovered" : "team card"}>
      <div className="content">
        <div className="front">
          <img src={image} alt={imgAlt} />
          <div className="detail">
            <div className="name">
              <h3>{name}</h3>
              <p>{position}</p>
            </div>
            <div className="social">
              {
                hasDiscord ?
                  <a href={discordLink} target='_blank'>
                    <img src={discordIcon} alt='' />
                  </a> :
                  ' '
              }
              {
                hasTwitter ?
                  <a href={twitterLink} target='_blank'>
                    <img src={twitterIcon} alt='' />
                  </a> :
                  ' '
              }
              {
                hasInsta ?
                  <a href={insta} target='_blank'>
                    <img src={instaIcon} alt='' />
                  </a> :
                  ' '
              }
              {
                hasWebsite ?
                  <a href={website} target='_blank'>
                    <img src={linkIcon} alt='' />
                  </a> :
                  ' '
              }
              {
                hasLinkedin ?
                  <a href={linkedinLink} target='_blank'>
                    <img src={linkedinIcon} alt='' />
                  </a> :
                  ' '
              }
            </div>
          </div>
          <button className="see" onClick={() => handleFlipping(id)}>See More</button>
        </div>
        <div className="back">
          <p dangerouslySetInnerHTML={createMarkup(detail)}></p>
          <button onClick={() => handleFlipping(id)}>Back</button>
        </div>
      </div>
    </div>
  )
}

export default TeamCard